export const HEADER_HEIGHT = 100;
export const EDITOR_HEADER_HEIGHT = 60;
export const EDITOR_LEFT_TABBAR_WIDTH = 56;
export const FLOW_HEADER_HEIGHT = 40;
export const LAYER_MENU_PADDING = 6;
